export default "__VITE_ASSET__DH3u3_be__"